<i18n
  src="@/locales/views/customer/quality_control/destination/list_processes.yml"
  lang="yaml"
></i18n>

<template>
  <bread-crumbs :labels="[module_name]"></bread-crumbs>

  <div
    v-if="load_data_general"
    class="bg-white shadow overflow-hidden sm:rounded-md"
  >
    <ul role="list" class="divide-y divide-slate-200">
      <li v-for="agro_exporter in agro_exporters" :key="agro_exporter.id">
        <div
          class="block hover:bg-slate-50 cursor-pointer"
          @click.prevent="goToShowAgroExporter(agro_exporter)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ agro_exporter.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible">
                  <i class="fa-solid fa-pen"></i>
                  <span class="space-icon"></span>
                  {{ $t("labels.manage_link") }}
                </a>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex space-x-0 sm:space-x-6">
                <p
                  v-for="(
                    number_containers, index
                  ) in agro_exporter.containers_by_crop"
                  :key="index"
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0"
                >
                  <i
                    class="fa-solid fa-container-storage flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ number_containers.name }}:
                  {{ number_containers.number_containers_with_inspects }} /
                  {{ number_containers.count_all }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/customer/requesters/quality_control/container/list_agro_exporters.js";

export default {
  name: "AEProductionContainerQualityListProcesses",
  props: ["customer_id"],
  data() {
    return {
      load_data_general: false,
      agro_exporters: []
    };
  },
  methods: {
    fetchAgroExporters: async function () {
      let response = await Requester.fetchAgroExporters(this.customer_id);
      this.agro_exporters = response.data;
      this.load_data_general = true;
    },
    goToShowAgroExporter: function (agro_exporter) {
      this.$router.push({
        name: "customer_quality_control_destination_list_containers_path",
        params: {
          agro_exporter_id: agro_exporter.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          customer_id: this.customer_id
        }
      }).then(() => this.fetchAgroExporters())
    );
  }
};
</script>
